import produce, { Draft } from 'immer';

// Models
import {
  BlacklistActionTypes,
  BlacklistsState,
} from 'app/modules/lists/models';
import BlacklistActions from 'app/modules/lists/actions';

const initialState: BlacklistsState = {
  blacklists: [],
  blacklistsCount: 0,
};

const reducer = (state = initialState, action: BlacklistActions) => {
  return produce(state, (draft: Draft<BlacklistsState>) => {
    switch (action.type) {
      case BlacklistActionTypes.RETRIEVE_BLACKLISTS_SUCCESS:
        draft.blacklists = action.payload.blacklists;
        draft.blacklistsCount = action.payload.count;
        return;

      case BlacklistActionTypes.CREATE_BLACKLIST_SUCCESS:
        draft.blacklists = [action.payload, ...draft.blacklists];
        draft.blacklistsCount += 1;
        return;
    }
  });
};

export { reducer as blacklistsReducer };
